import React from "react";
import { motion } from "framer-motion";
import CustomCheckbox from "Common/CustomCheckbox";
import Identification from "./Identification";
import Address from "./Address";
import Guarantor from "./Guarantor";
import ContactInformation from "./ContactInformation";
import PropTypes from "prop-types";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import SuperAccordion from "Components/SuperAccordion/SuperAccordion";

const BasicInformation = ({
  ptModel,
  validationModel,
  showOnlyRequired,
  sectionsOpen,
  onToggleSection,
  onShowOnlyRequiredChange,
  handleChange,
  onPasteEmail,
  onPasteZip,
  handleGuarantorZipChange,
  onToggleChange,
  hasInsuranceDataStarted,
}) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md mb-6">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-lg font-medium text-gray-900 mb-4 pb-2">
            Basic Information
          </h2>
        </div>
        <div className="flex items-center gap-4">
          <CustomCheckbox
            onChange={onShowOnlyRequiredChange}
            name="showOnlyRequired"
            checked={showOnlyRequired}
            label="Show only required fields"
          />
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="space-y-6"
      >
        <Identification
          ptModel={ptModel}
          validationModel={validationModel}
          showOnlyRequired={showOnlyRequired}
          sectionsOpen={sectionsOpen}
          onToggleSection={onToggleSection}
          handleChange={handleChange}
        />





        <Guarantor
          ptModel={ptModel}
          validationModel={validationModel}
          showOnlyRequired={showOnlyRequired}
          sectionsOpen={sectionsOpen}
          onToggleSection={onToggleSection}
          handleChange={handleChange}
          onPasteZip={handleGuarantorZipChange}
        />

        <div className="border rounded-lg p-4 space-y-4">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
          >
            <div
              className="flex items-center justify-between cursor-pointer py-2"
              onClick={() => onToggleSection("address")}
            >
              <h3 className="text-lg font-medium text-gray-900">Address</h3>
              {sectionsOpen.address ? (
                <FiChevronUp className="text-gray-500" />
              ) : (
                <FiChevronDown className="text-gray-500" />
              )}
            </div>
            <SuperAccordion show={sectionsOpen.address}>
              <Address
                ptModel={ptModel}
                validationModel={validationModel}
                handleChange={handleChange}
                onPasteZip={onPasteZip}
                hasInsuranceDataStarted={hasInsuranceDataStarted}
              />
              <ContactInformation
                ptModel={ptModel}
                validationModel={validationModel}
                handleChange={handleChange}
                onPasteEmail={onPasteEmail}
                onToggleChange={onToggleChange}
              />
            </SuperAccordion>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

BasicInformation.propTypes = {
  ptModel: PropTypes.object.isRequired,
  validationModel: PropTypes.object.isRequired,
  showOnlyRequired: PropTypes.bool.isRequired,
  sectionsOpen: PropTypes.object.isRequired,
  onToggleSection: PropTypes.func.isRequired,
  onShowOnlyRequiredChange: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  onPasteEmail: PropTypes.func.isRequired,
  onPasteZip: PropTypes.func.isRequired,
  handleGuarantorZipChange: PropTypes.func.isRequired,
  onToggleChange: PropTypes.func.isRequired,
  hasInsuranceDataStarted: PropTypes.func.isRequired,
};

export default BasicInformation;

